export const modalOpener = (setState) => {
  setState(true);
};
